import * as ACTIONTYPES from '../constants/actiontypes'
import AppConfig from '../../AppConfig';
import {
  togglePlay
} from './index'
import {
  getGalleryVisibility,
  getViewMode,
  getBookType,
} from '../selectors/selectors'

export const toggleGalleryVisibility = () => (dispatch, getState) => {

  const state = getState();
  const bookType = getBookType(state);
  const galleryVisibility = getGalleryVisibility(state);
  const viewMode = getViewMode(state);
  console.log('toggleGalleryVisibility')
  if (AppConfig.BOOK_TYPE_MODES[bookType].includes('video')) {
    if (galleryVisibility && viewMode !== 'text') {
      dispatch(togglePlay(true))
    } else {
      dispatch(togglePlay(false))
    }
  }

  dispatch({
    type: ACTIONTYPES.TOGGLE_GALLERY_VISIBILITY,
  });
};

export const showChapters = () => ({
  type: ACTIONTYPES.SHOW_CHAPTERS,
});

export const hideChapters = () => ({
  type: ACTIONTYPES.HIDE_CHAPTERS,
});




// WEBPACK FOOTER //
// ./src/store/actions/header-actions.js